import "./src/less/global.scss"
import React from "react"

export const wrapPageElement = ({ element, props }) => (
  <div key={props.location.key} className="page-transition">
    {element}
  </div>
)
